import { Formik } from "formik";
import { toast } from "react-hot-toast";
import { clean_shop_record } from "../../services/migration.services";
import { validationClean } from "../Shop/Shop.validation";
import CleanDataBaseForm from "./Forms/CleanDataBaseForm";

const initialState = {
  shop_username: "",
  order: false,
  kitchen: false,
  order_meal_item: false,
  diningtable: false,
  fooditem: false,
  food_category: false,
  food_item_addons: false,
  food_inventory: false,
  food_variant: false,
  expense: false,
  expense_category: false,
  inventory: false,
  inventory_category: false,
  customer: false,
  waiting_list: false,
};

const CleanDataBase = (props: any) => {
  const handleStepSubmit = async (value: any) => {
    const data: any = {
      shop_username: value?.shop_username,
      metadata: {
        order: value?.order,
        kitchen: value?.kitchen,
        order_meal_item: value?.order_meal_item,
        diningtable: value?.diningtable,
        fooditem: value?.fooditem,
        food_category: value?.food_category,
        food_item_addons: value?.food_item_addons,
        food_inventory: value?.food_inventory,
        food_variant: value?.food_variant,
        expense: value?.expense,
        expense_category: value?.expense_category,
        inventory: value?.inventory,
        inventory_category: value?.inventory_category,
        customer: value?.customer,
        waiting_list: value?.waiting_list,
      },
    };
    clean_shop_record(data)
      .then((res: any) => {
        if (res?.data?.status == 200) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err.message);
      });
  };
  return (
    <Formik
      onSubmit={(values) => handleStepSubmit(values)}
      enableReinitialize={true}
      initialValues={initialState}
      validate={(values) => {
        return validationClean(values);
      }}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        setFieldValue,
        touched,
      }) => (
        <>
          <form onSubmit={handleSubmit}>
            <div className="content-box">
              <div className="content-body">
                <div>
                  <CleanDataBaseForm
                    handleChange={handleChange}
                    errors={errors}
                    values={values}
                    touched={touched}
                  />
                  <div className="px-2 py-4 d-flex justify-content-center">
                    <button
                      className="btn btn-primary primary-out"
                      type="submit"
                    >
                      Clean Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default CleanDataBase;
